import { JettasinRedirectSection } from "components/jettasin/redirect-section/JettasinRedirectSection";

import styles from "./styles.module.css";

const AdditionalBenefits = () => (
  <div className={styles.wrapper} id="ek-faydalar" data-scroll-selector>
    <h2 className={styles.title}>Ek Faydalar</h2>
    <div className={styles.section}>
      <p className={styles.sectionSubInformation}>Evini Güvenle Taşı</p>
      <JettasinRedirectSection />
    </div>
  </div>
);

export default AdditionalBenefits;
